import { createFormHook } from '@tanstack/react-form';
import { fieldContext, formContext } from './formContext';
import { TextField } from './TextField';
import { CountryField } from './CountryField';

export { useFieldContext, useFormContext } from './formContext';

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: { TextField, CountryField },
  formComponents: {},
});
